import constants from 'common/helpers/constants'
import events from 'common/helpers/constants/snowplowEvents'

import { required, bool, integer, string, oneOf, oneOfTypes, arrayOf, number } from './validation'


const addressValidationPopupProperties = {
  paymentMethod: [
    required,
    oneOf([
      constants.paymentMethods.creditCard,
      constants.paymentMethods.payPal,
      constants.paymentMethods.applePay,
    ]),
  ],
}

const config = {
  // unit tests

  'Unit test': {
    properties: {
      userId: [ integer ],
      browser: [ string ],
      pageType: [ string ],
      page: [ string ],
    },
  },

  // landings

  [events.getStarted]: {
    description: 'Fires when you click on the "Get Started" button on landing pages',
    properties: {
      position: [ required, oneOf([ 0, 1, 2, 3, 4, 5 ]) ],
      placement: [ required, oneOf([
        'how it works', 'monthly supply', 'brand section', 'bottom section', 'features section',
        'first month', 'quotes', 'header', 'pick section', 'benefits section', 'questions section',
        'reviews section', 'size section', 'hero section', 'steps section', 'trends section', 'subscribe section',
        'product feed', 'events section', 'twoCases section', 'hamburger menu',
      ]) ],
    },
  },

  [events.registerEmailAlreadyExists]: {
    description: 'Fires when we display a message - email has been already registered',
  },

  [events.linkToLogin]: {
    description: 'Fires when you click on the "Please login" link in error on register pages',
  },

  [events.appStore.badgeClick]: {
    description: 'Fires when a customer clicks on the badge',
    properties: {
      page: [ required ],
    },
  },

  [events.appStore.banner]: {
    description: 'Fires when banner is shown on the page',
    properties: {
      page: [ required ],
    },
  },

  [events.appStore.bannerClick]: {
    description: 'Fires when a customer clicks on the GET button',
    properties: {
      page: [ required ],
    },
  },

  // site

  [events.welcomeSkip]: {
    description: 'Fires when you click on "skip" on the /welcome page',
  },

  [events.newOnboarding.mainPageOnboardingButton]: {
    description: 'Fires when you click onboarding button in main page',
    placement: [ required ],
    page: [ required ],
    type: [ required ],
  },

  [events.pickPage.skip]: {
    description: 'Fires when you click on the "skip" button on the /pick page',
  },
  [events.pickPage.addProduct]: {
    description: 'Fires when you add any product on the /pick page',
    properties: {
      productId: [ required, integer ],
      productName: [ required, string ],
    },
  },

  [events.emailFixed]: {
    description: 'Fires when you click here http://prntscr.com/lto1la on the register page',
  },

  [events.buyNow]: {
    description: 'Fires when you click here http://prntscr.com/lto1la on the register page',
    properties: {
      success: [ required, bool ],
      reason: [
        // undefined is ok, but if value exists it should be a string
        (value) => {
          if (process.env.EVENTS_DOC) {
            return [ 'String' ]
          }

          if (value && typeof value !== 'string') {
            return 'must be a string'
          }
        },
      ],
    },
  },

  [events.signup]: {
    description: 'Fires when you successfully created a new account',
  },

  [events.emptyQueueClick]: {
    description: 'Fires when you click on the empty queue cell http://prntscr.com/lto1y8',
  },

  [events.casesBannerClick]: {
    description: 'Fires when you click on this banner http://prntscr.com/ltse63',
  },

  [events.addressValidationPopup.open]: {
    description: 'Fires when you see this popup http://prntscr.com/ltscsu on a payment page',
    properties: addressValidationPopupProperties,
  },
  [events.addressValidationPopup.useAddress]: {
    description: 'Fires when you click "Use this address" http://prntscr.com/ltscsu on a payment page',
    properties: addressValidationPopupProperties,
  },
  [events.addressValidationPopup.editAddress]: {
    description: 'Fires when you click "Edit this address" http://prntscr.com/ltscsu on a payment page',
    properties: addressValidationPopupProperties,
  },

  [events.cardUpdateBannerClick]: {
    description: 'Fires when you click here http://prntscr.com/jakxnc',
  },

  [events.cardUpdatePopup]: {
    description: 'Fires when you card failed and you come to the website, you see a popup that asks you to update your billing info',
  },

  [events.burgerMenuClick]: {
    description: 'Fires when you click on the burger menu http://prntscr.com/ltsdcu',
  },

  [events.burgerMenuLinkClick]: {
    description: 'Fires when you click on the burger menu link https://prnt.sc/pcyjtd',
  },

  [events.burgerMenuInsideClick]: {
    description: 'Fires when you click on the burger menu text https://prnt.sc/pcyjzb',
  },

  [events.footerLinkClick]: {
    description: 'Fires when you click on the footer menu link https://prnt.sc/pcykfa',
  },

  [events.profileMenuClick]: {
    description: 'Fires when you click on the profile menu SB-75 https://take.ms/piSN2',
  },

  [events.desktopProfileMenuClick]: {
    description: 'Fires when you click on one of the links in this menu https://prnt.sc/ov7zc8',
    properties: {
      title: [ required, string ],
      link: [ string ],
    },
  },

  [events.paypalUpdateBannerClick]: {
    description: 'Fires when you click on this banner http://prntscr.com/ltse63',
  },

  [events.paypalUpdateClick]: {
    description: 'Fires when you click on update to paypal /paypal-update',
  },

  [events.changeFrequencyClick]: {
    description: 'Fires when you click on the change frequency btn http://prntscr.com/ew5fuf',
  },

  [events.writeReviewClick]: {
    description: 'Fires when you click on the "write a review" button on the product page http://prntscr.com/htk75w',
    properties: {
      productName: [ required, string ],
      productId: [ required, integer ],
    },
  },

  [events.reviewSubmit]: {
    description: 'Fires when you click on submit review button http://prntscr.com/h7gf5r',
    properties: {
      facebook: [ required, bool ],
      twitter: [ required, bool ],
    },
  },

  [events.subscribeNowLinkClick]: {
    description: 'Fires when you click on the "subscribe now" banner http://prntscr.com/ltoixo',
    properties: {
      placement: [ required, oneOf([ 'header banner', 'sidebar' ]) ],
    },
  },

  [events.orderStatusLinkClick]: {
    description: 'Fires when you click on the "order status" link',
    properties: {
      pageType: [ string ],
      page: [ string ],
    },
  },

  [events.productsInQueueLinkClick]: {
    description: 'Fires when you click on the "products in q" link',
    properties: {
      pageType: [ string ],
      page: [ string ],
    },
  },

  [events.ratedProductsLinkClick]: {
    description: 'Fires when you click on the "rated products" link',
    properties: {
      pageType: [ string ],
      page: [ string ],
    },
  },

  [events.reviewsWrittenLinkClick]: {
    description: 'Fires when you click on the "reviews written" link',
    properties: {
      pageType: [ string ],
      page: [ string ],
    },
  },

  [events.trackingNumberClick]: {
    description: 'Fires when you click on the tracking number link',
    properties: {
      pageType: [ string ],
      page: [ string ],
    },
  },

  [events.addToQueue]: {
    description: 'Fires when you click "Add to queue" button',
    properties: {
      productId: [ required, integer ],
      productName: [ required, string ],
      productCategory: [ string ],
      upchargePrice: [ integer ],
      sectionTab: [ string ],
      placement: [
        required,
        oneOf([
          'search bar',
          'tossin',
          'quick view',
          'hero section',
          'main page feed',
          'recommendations',
          'membership modal',
          'description section',
          'recommended section',
          'recommendations section',
          'perfume of the month',
          'received products list',
          'review item list modal',
          'recommendation tag modal',
          'note recommendations modal',
          'search not found suggestions',
          'review recommendations modal',
          'empty queue recommendations modal',
          'niche perfumes section',
          'new arrivals section',
          'bestsellers section',
          'featured',
          'top rated section',
          'smartsearch feed',
          'collection feed',
          'navigation dropdown',
          'products feed',
          'brand page feed',
          'story',
          'all skincare products',
          'all skincare mens products',
          'makeup all page',
          'makeup lip page',
          'makeup eye page',
          'makeup face page',
          'makeup cheek page',
          'makeup palettes page',
          'personalCare all page',
          'personalCare shower page',
          'personalCare handCreams page',
          'personalCare bodyMoisturizers page',
          'skincare cleansers products',
          'skincare lip products',
          'skincare eye products',
          'skincare masks products',
          'skincare moisturizers products',
          'skincare treatments products',
          'skincare wellness products',
          'skincare mens face products',
          'skincare mens eye products',
          'skincare mens shaving products',
          'popular in states',
          'fragrance finder feed',
          'horoscope feed',
          'seo page feed',
          'makeup tools page',
          'featured page',
          'seo page',
          'filter note results page',
        ]),
      ],
      pageType: [ string ],
      page: [ string ],
    },
  },

  [events.addToCart]: {
    description: 'Fires when you click "Add to cart" button',
    properties: {
      productId: [ required, integer ],
      productName: [ required, string ],
      productCategory: [ string ],
      productPrice: [ integer ],
      upchargePrice: [ integer ],
      sectionTab: [ string ],
      placement: [
        oneOf([
          'tossin',
          'quick view',
          'hero section',
          'main page feed',
          'recommendations',
          'membership modal',
          'description section',
          'recommended section',
          'perfume of the month',
          'received products list',
          'review item list modal',
          'recommendation tag modal',
          'note recommendations modal',
          'search not found suggestions',
          'review recommendations modal',
          'empty queue recommendations modal',
          'niche perfumes section',
          'new arrivals section',
          'bestsellers section',
          'top rated section',
          'smartsearch feed',
          'brand page feed',
          'makeup all page',
          'makeup cheek page',
        ]),
      ],
      pageType: [ string ],
      page: [ string ],
    },
  },

  [events.collectionAddToQueueAllButton]: {
    description: 'Fires when you click "Add all" on collection page',
    properties: {
      productNames: [ required, arrayOf(string) ],
      productIds: [ required, arrayOf(integer) ],
      productCategories: [ required, arrayOf(string) ],
    },
  },

  [events.searchInputClick]: {
    description: 'Fires when you click on search input',
  },

  [events.buyGiftSubscriptionClick]: {
    description: 'Fires when you click "Buy the gift for (him or her)" gift page',
    properties: {
      gender: [ required, oneOf([ 'male', 'female' ]) ],
    },
  },

  [events.buyGiftSubscriptionStepComplete]: {
    description: 'Fires when you complete gift subscription step on modals',
    properties: {
      stepName: [ required, oneOf([ 'choose size', 'recipient', 'choose date', 'choose specific date' ]) ],
      step: [ required, integer ],

      // step 'choose size'
      plan: [ integer ],
      price: [ integer ],

      // step 'recipient'
      email: [ string ],

      // step 'choose date'
      when: [ string ],
    },
  },

  [events.giftSelect]: {
    description: 'Fires when you click "Choose" button on gifts page',
    properties: {
      pageType: [ string ],
      type: [ string, oneOf([ 'subscription', 'boxes', 'cards' ]) ],
    },
  },

  [events.buyGiftCardClick]: {
    description: 'Fires when you click "Buy gift card" button on giftcard page',
    properties: {
      position: [ required, integer ],
      placement: [ required, oneOf([ 'hero', 'for every', 'use for' ]) ],
    },
  },

  [events.buyGiftCardStepComplete]: {
    description: 'Fires when you complete step in buy gift card flow',
    properties: {
      stepName: [
        required,
        oneOf([
          'choose value',
          'choose design',
          'delivery method',
          'recipient',
          'choose date',
          'choose specific date',
        ]),
      ],
      step: [ required, integer ],

      // step 'choose value'
      placement: [ oneOf([ 'modal', 'in page' ])],
      value: [ integer ],

      // step 'choose design'
      styleId: [ integer ],

      // step 'delivery method'
      method: [ oneOf([ 'mail', 'email' ])],

      // step 'recipient'
      email: [ string ],

      // step 'choose date'
      when: [ string ],
    },
  },

  [events.navigationMenuClick]: {
    description: 'Fires when you click on any element of the navigation menu',
    properties: {
      title: [ required, string ],
      link: [ string ],
    },
  },

  [events.subscriptionReminderPopup]: {
    description: 'Fires when the remind popup shows and asking you to subscribe (visible when you add 1st and every 5th product to the queue)',
    properties: {
      productCount: [ required, integer ],
    },
  },

  [events.quickViewClick]: {
    description: 'Fires when you click "Quick view" button',
    properties: {
      page: [ string ],
      pageType: [ string ],
      placement: [ string ],
      productId: [ required, integer ],
      productName: [ required, string ],
      productCategory: [ string ], // TODO should be required, but there is undefined in category for some reason..
    },
  },

  [events.quizStepComplete]: {
    description: 'Fires when you open the second step on the /onboaring quiz',
    properties: {
      // all steps
      step: [ required, integer ],
      stepName: [ required, oneOf([ 'place', 'flavour', 'drink', 'choose perfume' ]) ],

      // first three steps
      tagId: [ string ],
      tagName: [ string ],

      // fourth step
      searchProductIds: [ arrayOf(integer) ],
      productListIds: [ arrayOf(integer) ],
    },
  },

  [events.smartSearchTagClick]: {
    description: 'Fires when you click on a tag in a smart search http://prntscr.com/klt9zt',
    properties: {
      gender: [ required, oneOf([ 'male', 'female' ]) ],
      tagId: [ required, integer ],
      tagName: [ required, string ],
    },
  },

  [events.editReviewClick]: {
    description: 'Fires when you click on "Edit review" button',
  },

  [events.shareButtonClick]: {
    description: 'Fires when you click on any share button on the /invite page http://prntscr.com/ltohna',
    properties: {
      type: [ required, oneOf([ 'facebook', 'messenger', 'gmail', 'email', 'link', 'sms' ]) ],
    },
  },

  [events.skipMonthClick]: {
    description: 'Fires when you click on "Skip a month" button on page http://prntscr.com/f2wqjd or in cancel subscription popup',
    properties: {
      pageType: [ string ],
      page: [ string ],
      placement: [ required, oneOf([ 'in page', 'cancel subscription popup' ]) ],
    },
  },

  [events.cancelSubscriptionClick]: {
    description: 'Fires when you click on "Cancel subscription" button http://prntscr.com/f2wq9i',
  },

  [events.unsubscribeReason]: {
    description: 'When you complete "unsubscribe reason" step cancel subscription',
    properties: {
      reason: [ required, string ],
      comment: [ string ],
    },
  },

  /*

    // TODO move this to smth like draw.io

    Flows:

    [ModalName] means that cancellation subscription flow was finished on previous step (cancelled or discountinued)

    cancel subscription -> (#1) OneLastQuestionModal -> UnsubscribeProductsModal -> (unsubscribe) -> RefundModal
                                                                                                  -> SubscriptionWasCancelledModal

                                                     -> ProlongOfferModal -> (unsubscribe) -> ProlongThankYouModal

                                                     -> (unsubscribe) -> RefundModal

                                                     -> (unsubscribe) -> SubscriptionWasCancelledModal -> (subscribe) -> WelcomeBackModal
                                                                                                       -> ResubscribeSuccessModal

                      -> (#2) BeforeYouGoModal -> PauseSubscriptionModal
                                               -> OneLastQuestionModal (check #1 above)

                      -> CancelSubscriptionModal -> OneLastQuestionModal (check #1 above)
                                                 -> BeforeYouGoModal (check #2 above)

   */
  [events.cancelSubscriptionStepComplete]: {
    description: 'Fires when you click on "Cancel subscription" button http://prntscr.com/f2wq9i',
    properties: {
      stepName: [ required, string, oneOf([
        'before you go',
        'are you sure',
        'pause subscription',
        'unsubscribe reason',
        'prolong offer',
        'try other products',
        'shipping and billing issues',
        'feedback modal',
      ]) ],
      action: [ required, string, oneOf([
        'close',
        'skip month',
        'change frequency',
        'go back',
        'pause subscription',
        'never mind',
        'accept discount',
        'product click',
        'update address',
      ]) ],

      // prolong offer step
      defaultPrice: [ oneOfTypes([ string, number ]) ], // TODO shold be required by "prolong offer" step
      discountPrice: [ oneOfTypes([ string, number ]) ],
      monthCount: [ integer ],

      // try other products step
      productName: [ string, oneOf([ 'handCreams', 'productsForBody', 'scentedCandles', 'bodyLip' ]) ],
    },
  },

  [events.resubscribeClick]: {
    description: 'Fires when you click on "Resubscribe" button or link',
    properties: {
      pageType: [ string ],
      page: [ string ],
      placement: [ required, oneOf([
        'sidebar',
        'user menu',
        'hamburger menu',
        'profile menu',
        'header banner',
        'main page banner',
        'need subscription popup',
        'get back together popup',
        'tracking motivation message',
        'product page',
        'queue page',
      ]) ],
    },
  },

  [events.upgradeSubscriptionClick]: {
    description: 'Fires when you click on a button or link to upgrade your plan http://prntscr.com/mhca4p, http://prntscr.com/mhcaer',
    properties: {
      pageType: [ string ],
      page: [ string ],
      placement: [ required, oneOf([
        'queue',
        'footer',
        'sidebar',
        'user menu',
        'profile menu',
        'hamburger menu',
        'main page banner',
        '2-3 scents popup',
      ]) ],
    },
  },

  [events.unpauseClick]: {
    description: 'Fires when you click on a button or link to unpause your subscription',
    properties: {
      pageType: [ string ],
      page: [ string ],
      placement: [ required, oneOf([
        'sidebar',
        'user menu',
        'profile menu',
        'hamburger menu',
        'header banner',
        'main page banner',
        'order status',
        'need unpause popup',
        'pause success popup',
        'preparing downgrade popup',
        'unpause subscription popup',
        'tracking motivation message',
      ]) ],
    },
  },

  [events.subscriptionUnpausePopup]: {
    description: 'Fires when your subscription is on pause and you come to the website we ask you to unpause your susbcription',
    properties: {
      modalId: [ required, integer ],
    },
  },

  [events.optOutPremiumPopup]: {
    description: 'Fires when you click on the "do not show me this..." link on the add to q popup',
  },

  [events.premiumProductDescriptionClick]: {
    description: 'Fires when you click on the premium product description',
    properties: {
      placement: [
        required,
        oneOf([ 'add to queue popup', 'quick view', 'product page', 'skincare product details modal']),
      ],
    },
  },

  [events.thankYouQueuePopup]: {
    description: 'Fires when the popup shows up http://prntscr.com/iqtfbn',
  },

  [events.thankYouQueuePopupClick]: {
    description: 'Fires when you click on the call to action button http://prntscr.com/iqtg3d ',
    properties: {
      link: [ required, string ],
    },
  },

  [events.search.bestsellersClick]: {
    description: 'User clicked on suggestion if nothing found - http://prntscr.com/k7ko4e',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ required, string ],
    },
  },

  [events.search.brandClick]: {
    description: 'User clicked on brandname suggestion http://prntscr.com/k7k5ss',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ required, string ],
      brand: [ required, string ],
    },
  },

  [events.search.brandUnavailableClick]: {
    description: 'User clicked on unavailable brand e.g. Chanel http://prntscr.com/kdt‌bqv',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ required, string ],
      brand: [ required, string ],
    },
  },

  [events.search.noteClick]: {
    description: 'User clicked on note suggestion',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ required, string ],
      note: [ required, string ],
    },
  },

  [events.search.pageClick]: {
    description: 'User clicked on page suggestion',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ required, string ],
      pageName: [ required, string ],
    },
  },

  [events.search.cancel]: {
    description: '(if user doesn’t find anything interesting and closes search) fires when users are closing the search input http://prntscr.com/k8z8xu',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ string ],
    },
  },

  [events.search.nameClick]: {
    description: 'User clicked on fragrance name suggestion http://prntscr.com/k66c4q',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ required, string ],
      productId: [ required, integer ],
      productName: [ required, string ],
      position: [ required, integer ],
    },
  },

  [events.search.nameUnavailableClick]: {
    description: 'User clicked on unavailable name http://prntscr.com/kdth4l',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ required, string ],
      productId: [ required, integer ],
      productName: [ required, string ],
      position: [ required, integer ],
    },
  },

  [events.search.suggestionClick]: {
    description: 'User clicked on suggestion from search empty state',
    properties: {
      pageType: [ string ],
      page: [ string ],
      suggestionType: [ required, oneOf([
        'collections',
        'bestsellers',
        'candles',
        'palettes',
        'quiz',
        'makeup',
        'banner',
      ]) ],
      position: [ integer ],
    },
  },

  [events.search.query]: {
    description: 'User used search input and submitted it',
    properties: {
      pageType: [ string ],
      page: [ string ],
      query: [ string ],
    },
  },

  [events.queueProductRemove]: {
    description: 'User removed product from queue',
    properties: {
      pageType: [ string ],
      page: [ string ],
      placement: [ required, oneOf([
        'premium product popup',
        'queue',
        'thankYou page',
        'incubator queue',
        'thank you page',
      ]) ],
      productName: [ required, string ],
      productBrand: [ required, string ],
      productId: [ required, integer ],
    },
  },

  [events.queueProductMove]: {
    description: 'User moved product in queue',
    properties: {
      pageType: [ string ],
      page: [ string ],
      indexFrom: [ required, integer ],
      indexTo: [ required, integer ],
      productName: [ required, string ],
      productBrand: [ required, string ],
      productId: [ required, integer ],
    },
  },

  [events.queueProductMove]: {
    description: 'User moved product in queue',
    properties: {
      pageType: [ string ],
      page: [ string ],
      indexFrom: [ required, integer ],
      indexTo: [ required, integer ],
      productName: [ required, string ],
      productBrand: [ required, string ],
      productId: [ required, integer ],
    },
  },

  [events.sameProductPopup]: {
    description: 'When user see popup http://prntscr.com/mn4lly',
    properties: {
      pageType: [ string ],
      page: [ string ],
      productId: [ required, integer ],
      productName: [ required, string ],
      productBrand: [ required, string ],
      productCategory: [ string ], // TODO should be required, but there is undefined in category for some reason..
    },
  },

  [events.cartClick]: {
    description: 'When user click cart icon in header',
    properties: {
      pageType: [ string ],
      page: [ string ],
    },
  },

  // page visit

  [events.pageVisit.productPage]: {
    description: 'When you visit a product page',
    properties: {
      productId: [ required, integer ],
      productName: [ required, string ],
      productCategory: [ string ], // TODO should be required, but there is undefined in category for some reason..
    },
  },

  [events.pageVisit.productOfTheMonthPage]: {
    description: 'When you visit https://www.scentbird.com/subscription/perfume-of-the-month or any other product of the month',
    properties: {
      date: [ required, string ],
      type: [ required, string ],
    },
  },

  [events.recommendedProductView]: {
    description: 'When recommended products in viewport',
    properties: {
      productName: [ required, string ],
      productId: [ required, integer ],
      recommendedProductId: [ required, integer ],
      recommendedProductName: [ required, string ],
      recommenderProvider: [ required, string ],
      recommenderVersion: [ required, string ],
      scrollType: [ required, oneOf([
        'horizontal',
        'vertical',
      ]) ],
    },
  },

  [events.mainPageLoginClick]: {
    description: 'Fires when you click on login button on main page', // TODO @ivashev add config if needed
  },

  [events.mobileMenuFirstClick]: {
    description: 'When you click on the hamburger or profile button in a new mobile header SB-75, should be fired once',
    properties: {
      type: [ required, oneOf([
        'burger',
        'profile',
      ]) ],
    },
  },

  [events.promote.buyQueue]: {
    description: 'When user click on banner or top link on the Queue page',
    properties: {
      placement: [ required, string ],
      page: [ required, string ],
      type: [ string ],
    },
  },

  [events.promote.casesBanner]: {
    description: 'When user click on banner or top link on the Queue page',
    properties: {
      placement: [ required, string ],
      page: [ required, string ],
      type: [ string ],
    },
  },

  [events.promote.subscriptionUpgrade]: {
    description: 'When user click on banner or top link on the Queue page',
    properties: {
      placement: [ required, string ],
      page: [ required, string ],
      type: [ string ],
    },
  },

  [events.productCard.readMoreClick]: {
    description: 'Fires when you click on the read more link https://prnt.sc/op4bwh',
    properties: {
      productId: [ required, integer ],
      productName: [ required, string ],
    },
  },

  [events.productCard.seeDetailsClick]: {
    description: 'Fires when you click on the see details link https://prnt.sc/op4bwh',
    properties: {
      productId: [ required, integer ],
      productName: [ required, string ],
    },
  },

  [events.mainPagePopularNotesClick]: {
    description: 'Fires when you click on one of the notes https://prnt.sc/op4a47',
    properties: {
      note: [ required, string ],
      gender: [ required, string ],
    },
  },

  [events.noteProductsPage]: {
    description: 'Fires when you visit this page https://prnt.sc/op4b6n',
    properties: {
      note: [ required, string ],
    },
  },

  [events.collectionForSale.visit]: {
    description: 'Fires when you visit collection set page',
    properties: {
      collectionSetName: [ required, string ],
      collectionSetId: [ required, number ],
    },
  },

  [events.collectionForSale.coverClick]: {
    description: 'Fires when you click on collection cover on tracking page, collections page, collections for sale',
    properties: {
      page: [ required, string ],
    },
  },

  [events.collectionForSale.collections]: {
    description: 'Fires when you visit list of collection page',
  },

  [events.collectionForSale.continueClick]: {
    description: 'Fires when you click on "buy in one click" or "checkout"',
    properties: {
      type: [ required, oneOf([ 'one click', 'checkout' ]) ],
    },
  },

  [events.collectionForSale.bannerClick]: {
    description: 'Fires when you click on this banner https://prnt.sc/oooppm',
  },

  [events.productFeedBanner.click]: {
    description: 'Fires when you click on this banner https://monosnap.com/file/UTSbIYqmyroDGGOTesGpq1Y8XZVJA9',
  },

  [events.productFeedBanner.appear]: {
    description: 'Fires when you see this banner https://monosnap.com/file/UTSbIYqmyroDGGOTesGpq1Y8XZVJA9',
  },

  [events.upgradePrepaidPlansPage.visit]: {
    description: 'Fires when you visit /prepaid-plans',
  },

  [events.upgradePrepaidPlansPage.upgradeOptionClick]: {
    description: 'Fires when you click on one of the plans https://prnt.sc/ov7l85',
    properties: {
      type: [ required, oneOf([ '3 months', '6 months', '12 months' ]) ],
    },
  },

  [events.collectionPage]: {
    description: 'Fires when you visit any collection page. Type "internal" if logged in, "external" if not',
    properties: {
      type: [ required, oneOf([ 'internal', 'external' ]) ], // internal -> loggedIn, CollectionPage; external -> CollectionLandingPage
      collectionName: [ required, string ],
      collectionUrl: [ required, string ],
      collectionId: [ required, number ],
    },
  },

  [events.unsubscribeReasonsPopup.open]: {
    description: 'Fires when you see this popup https://prnt.sc/p4xh7r',
  },

  [events.unsubscribeReasonsPopup.close]: {
    description: 'Fires when you close this popup https://prnt.sc/p4xh7r',
    properties: {
      type: [ required, oneOf([ 'never mind', 'exit sign', 'outside' ]) ],
    },
  },
}


export default config
